import React from "react";
import { toast } from "react-toastify";
import { ErrorToast } from "../pure-components/CustomToast";
import CookieManager from "./CookieManager";
import youtubeLogo from "../assets/logo/youtube-icon.png";
import facebookLogo from "../assets/logo/facebookLogo.png";
import instaLogo from "../assets/logo/instaLogo.png";
import snapchatLogo from "../assets/logo/snapchatLogo.png";
import xLogo from "../assets/logo/x_logo.png";
import websiteLogo from "../assets/logo/websiteLogo.png";
import rssLogo from "../assets/logo/rssLogo.png";
import Constants from "./constants";

function signOut() {
    var date = new Date();
    //setting past time to expire cookie data
		date.setTime(date.getTime() + (-1*24*60*60*1000));
    document.cookie = 'user-data=""; expires=' + date.toUTCString() + '; path=/';
    document.cookie = 'x-auth=""; expires=' + date.toUTCString() + '; path=/';
    document.cookie = 'x-access-token=""; expires=' + date.toUTCString() + '; path=/';
    document.cookie = 'last-seen=""; expires=' + date.toUTCString() + '; path=/';
    // console.log('signing out')
    window.location = '/login';
    clearStorageAndCookie();
}

function clearStorageAndCookie() {
  localStorage.clear();
  CookieManager.deleteCookie('user-data');
  CookieManager.deleteCookie('x-auth');
  CookieManager.deleteCookie('x-access-token');
}

function sanitizeAndCreateJSON(info) {
  let encodedString = encodeURI(info);
  let splittedString = encodedString.split('%0A');
 //console.log({splittedString});
  let obj = {}
  let decodedString = splittedString.map( str => {
  //  console.log(str)
    if (str !== '') {
      let keyValue = decodeURI(str).split(':');
    //  console.log(keyValue);
      if((keyValue[0])?.length > 0)
        obj[(keyValue[0])?.toString().trim()] = (keyValue[1])?.toString().trim();
    }
  });
  return obj
}
function debounce(fn, wait) {
  let t;
  return function () {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, arguments), wait)
  }
}

function encode(text) {
  if(text?.trim().length){
    text = Buffer(text).toString("base64");
    text = text.split("").reverse().join("");
    const n = (text.length/2) % text.length;
    return (text.slice(n) + text.slice(0, n)); 
  }
  return text;
}

function decode(data) {
  if(data?.trim().length){
      data = data.split("").reverse().join("");
      const n = (data.length/2) % data.length;
      data = (data.slice(n) + data.slice(0, n)); 
      data = new Buffer(data, 'base64').toString("ascii");
  }
  return data;
};

function resolveStringValue(data) {
  if(data?.trim().length > 0)
    return data.trim();
  return "";
};

function handleError(res){
  //if token invalid, sign out the user
  if(res?.status === 400 && res?.key === "invalid_token"){
    toast(({ closeToast }) => <ErrorToast message={"Session expired, please login to continue."}/>);
    setTimeout(() => {
      signOut();
    }, 5000);
  }else{
    toast(({ closeToast }) => <ErrorToast message={(res?.mssg?.length ? res?.mssg : "") +  (res?.message?.length ? res?.message : "")}/>);
  }
}

function isExist(dataObj){
  if(dataObj===null || dataObj ===undefined)
    return false;
  else{
    return true;
  }
}

function firstWordToUpper(str){
  if(str?.length > 0)
    return str.split(".")?.map((str1, index) =>
    str1.charAt(0).toUpperCase() + str1.slice(1)).join();
  else
    return null;
}

const getArtistName = (artists) => {  
  let name = "";
  if(artists?.length > 0)
    artists.map((elem, index) => {
      if(index < artists.length - 1)
        name = name + `${elem?.artist?.full_name}, `
      else
      name = name + elem?.artist?.full_name
    })
  return name;
}

const getArtistNameFromList = (artists) => {  
  let name = "";
  if(artists?.length > 0)
    artists.map((elem, index) => {
      if(index < artists.length - 1)
        name = name + `${elem?.name}, `
      else
      name = name + elem?.name
    })
  return name;
}

const addAttributeToObject = (obj, key, value) => {
  if((obj!==null && obj !== undefined) && key?.length && value?.length){
      obj[key] = value;
  }
  return obj;
};

const getChannelIcon = (type) => {
  let elem = "";
  switch(type){
    case Constants.CHANNELS.youtube : 
      elem = <div class="rounded-full filter-tile-pink text-title px-1 py-0.5 row-line">
        <img
          src={youtubeLogo}
          alt="logo"
          className="h-4"
          title="text search"
        />
        
      </div>
      break;
    case Constants.CHANNELS.facebook : 
      elem = <div class="rounded-full filter-tile-pink text-title px-1 py-0.5 row-line">
        <img
          src={facebookLogo}
          alt="logo"
          className="h-4"
          title="youtube link search"
        />
      </div>
      break;
    case Constants.CHANNELS.instagram : 
      elem = <div class="rounded-full filter-tile-pink text-title px-1 py-0.5 row-line">
        <img
          src={instaLogo}
          alt="logo"
          className="h-4"
          title="spotify link search"
        />
      </div>
      break;
    case Constants.CHANNELS.snapchat : 
      elem = <div class="rounded-full filter-tile-pink text-title px-1 py-0.5 row-line">
        <img
          src={snapchatLogo}
          alt="logo"
          className="h-4"
          title="spotify link search"
        />
      </div>
      break;
    case Constants.CHANNELS.x : 
      elem = <div class="rounded-full filter-tile-pink text-title px-1 py-0.5 row-line">
        <img
          src={xLogo}
          alt="logo"
          className="h-4"
          title="spotify link search"
        />
      </div>
      break;
    case Constants.CHANNELS.website : 
      elem = <div class="rounded-full filter-tile-pink text-title px-1 py-0.5 row-line">
        <img
          src={websiteLogo}
          alt="logo"
          className="h-4"
          title="spotify link search"
        />
      </div>
      break;
  case Constants.CHANNELS.rss : 
    elem = <div class="rounded-full filter-tile-pink text-title px-1 py-0.5 row-line">
      <img
        src={rssLogo}
        alt="logo"
        className="h-4"
        title="spotify link search"
      />
    </div>
    break;
  }

  return (elem)
}


const getArtworkURL = (albumId) => {
  return `https://edge5.harvestmedia.net/assets/albumart/ce7156bfec5d262eb7b02c575c8d48f2d2e605bd/${albumId}/300/300`
}
const getLargeArtworkURL = (albumId) => {
  return `https://edge5.harvestmedia.net/assets/albumart/ce7156bfec5d262eb7b02c575c8d48f2d2e605bd/${albumId}/1080/720`
}

const getLibraryLogoURL = (libId) => {
  return `https://d3vy0pmxxxelni.cloudfront.net/assets/librarylogo/af7f0148dae40c9e3cc627ba17d132a99a3f4523/${libId}/300/300`
}
const getLargeLibraryLogoURL = (libId) => {
  return `https://d3vy0pmxxxelni.cloudfront.net/assets/librarylogo/af7f0148dae40c9e3cc627ba17d132a99a3f4523/${libId}/1080/720`
}
const playTrackURL = (trackId) => {
  return `https://d3vy0pmxxxelni.cloudfront.net/assets/samples/ce7156bfec5d262eb7b02c575c8d48f2d2e605bd/${trackId}`
}

const getWaveformURL = (trackId) => {
  return `https://d3vy0pmxxxelni.cloudfront.net/assets/waveforms/b21fe83f6ec3e1a0cc1f55399413c83ab7f0345c/${trackId}/600/60/black/red/1/1`
}
const getWaveformDataURL = (trackId) => {
  return `https://d3vy0pmxxxelni.cloudfront.net/assets/waveform_data/b21fe83f6ec3e1a0cc1f55399413c83ab7f0345c/${trackId}/JSON`
}

const getComposers = (compList) => {
  const compData = {};
  if(compList?.length > 0){
    compList.forEach(elem => {
      compData[elem.ID] = elem.Name + " " + elem.LastName
    });
  }
  return compData;
}

const getComposerNames = (compList) => {
  const compData = getComposers(compList);
  let compName = "";
  if(Object.keys(compData)?.length > 0){
    Object.keys(compData).forEach((elem, idx) => {
      if(idx === (Object.keys(compData).length - 1)){
        compName = compName + compData[elem];
      }else{
        compName = compName + compData[elem] + ", ";
      }
    })
  }
  return compName;
}

const getGlobalRoutes = () => {
  return [
    "/home",
    "home/#card-container",
    "/info",
    "/about",
    "/terms",
    "/privacy",
    "/cookies",
    "/contact",
    "/faqs",
    "/register/free",
    "/register/solo",
    "/register/pro",
    "/home/country-not-available",
    "/blogs",
    "/blog/"
  ]
}

const getSearchIcon = (color = "#767577", width=30, height = 30) => {
  const icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={`${width}`} height={`${height}`}>
                <circle cx="9" cy="10" r="5.5" fill="none" stroke={`${color}`} strokeWidth="1.8"/>
                <circle cx="14" cy="10" r="5.5" fill="none" stroke={`${color}`} strokeWidth="1.8"/>
                <line x1="17.5" y1="15.5" x2="21" y2="19" stroke={`${color}`} strokeWidth="2" strokeLinecap="round"/>
              </svg>
  return icon;
}

const getRandomMusicKey = () =>{
  const keySet = ["Indian","Horror","Rock","Blues","Jazz","Uplifting","Strings","Acoustic","Ambient","Crime","Fear",
    "Fun","Piano","Ethereal","Trailer","Suspense","Minimalist","Classic","Vintage","hip hop","Electronic","Female",
    "Male","Romantic","Sport","Sitar","Lo-fi","Tension","Synth","Epic","Intimate","Distorted","Sex"]
  const size = 33;
  const randomIdx = Math.floor(Math.random() * (size + 1));
  // console.log("idx : ", randomIdx, keySet[randomIdx]);
  if(randomIdx < size)
    return keySet[randomIdx];
  else
    return keySet[keySet.length -1];
}
const Helper = { 
  signOut, 
  sanitizeAndCreateJSON, 
  debounce, 
  clearStorageAndCookie, 
  encode, 
  decode, 
  resolveStringValue, 
  handleError, 
  isExist, 
  firstWordToUpper, 
  getArtistName, 
  addAttributeToObject, 
  getArtistNameFromList, 
  getChannelIcon, 
  getArtworkURL, 
  getLibraryLogoURL, 
  playTrackURL, 
  getWaveformURL,
  getWaveformDataURL, 
  getComposers, 
  getComposerNames,
  getLargeArtworkURL,
  getLargeLibraryLogoURL,

  getGlobalRoutes,
  getSearchIcon,
  getRandomMusicKey
 };

export default Helper;